'use strict'
import errorService from '@/services/errorService'

var config, service, analisi;
(async () => {
  if (!config || !service) {
    await getConfigFile();
  }
})();

async function getConfigFile() {
  const response = await fetch(process.env.BASE_URL + "config.json");
  config = await response.json();
  service = config.VUE_APP_MOL_API_GATEWAY
  analisi = config.VUE_APP_MOL_S_ANALYSIS
}

async function vendutoDelGiorno() {
  
  const filtro = {
    start: request.params.start,
    end: request.params.end
  }

}

// Inserendo il tag dashboard nella causale, posso scegliere quale causale fare vedere negli snipplet nella dashboard.
// Se necessario posso inserire anche array di dashboard per ogni causale, in modo che possa comparire su più resoconti

async function dashboardVendutoPeriodo(filtro, tipoRiepilogo, tipoDashboard) {
  if (!config || !service) {
    await getConfigFile();
  }
  try {
    const data = {
      filtro,
      tipoRiepilogo,
      tipoDashboard
    }
    const response = await fetch(`${service}/${analisi}/dashboard/venduto`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data)
    })

    const result = await response.json();
    return result
  } catch (error) {
    errorService.onError(error, 'dashboardVendutoPeriodo')
    return error
  }
}

async function dashboardVendutoPeriodoGruppo(filtro, tipoRiepilogo, tipoDashboard, gruppo) {
  if (!config || !service) {
    await getConfigFile();
  }
  try {
    const data = {
      filtro,
      tipoRiepilogo,
      tipoDashboard,
      gruppo
    }
    const response = await fetch(`${service}/${analisi}/dashboard/venduto/gruppo`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data)
    })

    const result = await response.json();
    return result
  } catch (error) {
    errorService.onError(error, 'dashboardVendutoPeriodoGruppo')
    return error
  }
}

async function dashboardVendutoUltimo(filtro, tipoRiepilogo, tipoDashboard) {
  if (!config || !service) {
    await getConfigFile();
  }
  try {
    const data = {
      filtro,
      tipoRiepilogo,
      tipoDashboard
    }
    const response = await fetch(`${service}/${analisi}/dashboard/venduto/ultimo`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data)
    })

    const result = await response.json();
    return result
  } catch (error) {
    errorService.onError(error, 'dashboardVendutoUltimo')
    return error
  }
}

async function dashboardVendutoPeriodoV2(filtro, tipoRiepilogo, tipoDashboard) {
  if (!config || !service) {
    await getConfigFile();
  }
  try {
    const data = {
      filtro,
      tipoRiepilogo,
      tipoDashboard
    }
    const response = await fetch(`${service}/${analisi}/dashboard/v2/venduto`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data)
    })

    const result = await response.json();
    return result
  } catch (error) {
    errorService.onError(error, 'dashboardVendutoPeriodoV2')
    return error
  }
}

async function dashboardVendutoPeriodoGruppoV2(filtro, tipoRiepilogo, tipoDashboard, gruppo) {
  if (!config || !service) {
    await getConfigFile();
  }
  try {
    const data = {
      filtro,
      tipoRiepilogo,
      tipoDashboard,
      gruppo
    }
    const response = await fetch(`${service}/${analisi}/dashboard/v2/venduto/gruppo`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data)
    })

    const result = await response.json();
    return result
  } catch (error) {
    errorService.onError(error, 'dashboardVendutoPeriodoGruppoV2')
    return error
  }
}

async function dashboardVendutoPeriodoGruppoV2SoloScontrini(filtro, tipoRiepilogo, tipoDashboard, gruppo, payload) {
  if (!config || !service) {
    await getConfigFile();
  }
  try {
    const data = {
      filtro,
      tipoRiepilogo,
      tipoDashboard,
      gruppo,
      payload
    }
    const response = await fetch(`${service}/${analisi}/dashboard/v2/venduto/gruppo/scontrini`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data)
    })

    const result = await response.json();
    return result
  } catch (error) {
    errorService.onError(error, 'dashboardVendutoPeriodoGruppoV2')
    return error
  }
}

export default {
  dashboardVendutoPeriodo,
  dashboardVendutoPeriodoGruppo,
  dashboardVendutoUltimo,
  dashboardVendutoPeriodoV2,
  dashboardVendutoPeriodoGruppoV2,
  dashboardVendutoPeriodoGruppoV2SoloScontrini
}
